// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Componente principal del calendario */
.calendar-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Montserrat', sans-serif;
  background: #f5f5f5; /* Fondo gris como en la imagen */
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* Header simple como en la imagen */
.events-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 20px;
}


.events-title {
  font-size: 24px;
  font-weight: bold;
  margin: 0;
  color: #333;
}

.add-event-btn {
  background: #ff8c00; /* Naranja como la barra */
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 50%; /* Botón circular */
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}

.add-event-btn:hover {
  background: #ff6b00; /* Naranja más oscuro */
  transform: scale(1.05);
}

/* Controles del calendario */
.calendar-controls {
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.view-controls {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.view-btn {
  background: #f8f9fa;
  border: 2px solid #e9ecef;
  padding: 12px 20px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
}

.view-btn:hover {
  background: #e9ecef;
  border-color: #dee2e6;
}

.view-btn.active {
  background: #007bff;
  color: white;
  border-color: #007bff;
}

.filter-controls {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  align-items: center;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-label {
  font-weight: 600;
  color: #495057;
  font-size: 14px;
}

.filter-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.filter-btn {
  background: white;
  border: 2px solid #e9ecef;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
}

.filter-btn:hover {
  background: #f8f9fa;
  border-color: #dee2e6;
}

.filter-btn.active {
  background: #007bff;
  color: white;
  border-color: #007bff;
}

.clear-filters-btn {
  background: #dc3545;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
}

.clear-filters-btn:hover {
  background: #c82333;
  transform: translateY(-1px);
}

/* Contenido principal */
.calendar-content {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Lista Simple de Eventos - Diseño como en la imagen */
.events-list-container {
  background: #f5f5f5; /* Fondo gris como en la imagen */
  border-radius: 8px;
  padding: 20px;
  margin: 20px 0;
}

.events-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.event-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 0;
  background: transparent; /* Sin fondo, todo en gris */
  border: none;
  cursor: default;
}

.event-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.event-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.event-title-simple {
  background: #FBC773; /* Color más suave */
  color: white;
  padding: 12px 16px;
  border-radius: 6px;
  font-size: 18px;
  font-weight: 600;
  text-align: left; /* Texto alineado a la izquierda */
  width: 25%; /* Solo cubre el 25% del ancho */
  box-sizing: border-box;
  transition: background-color 0.2s ease;
  display: inline-block; /* Para que no ocupe todo el ancho */
}

.event-title-simple:hover {
  background: #F4B942; /* Color más oscuro al hover */
}

.event-description {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin: 16px 0;
}

.description-label {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  min-width: 100px;
  flex-shrink: 0;
  margin-top: 8px;
}

.description-input {
  flex: 1;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.4;
  resize: vertical;
  min-height: 60px;
  background: white;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.description-input:focus {
  outline: none;
  border-color: #FBC773;
  box-shadow: 0 0 0 3px rgba(251, 199, 115, 0.1);
  background: #fff8f0;
}

.event-dates {
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 16px 0;
}

.dates-label {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  min-width: 100px;
  flex-shrink: 0;
}

.dates-inputs {
  display: flex;
  gap: 12px;
}

.date-input {
  padding: 10px 14px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  width: max-content;
  text-align: center;
  background: white;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  font-weight: 500;
}

.date-input:focus {
  outline: none;
  border-color: #FBC773;
  box-shadow: 0 0 0 3px rgba(251, 199, 115, 0.1);
  background: #fff8f0;
}

.date-input:hover {
  border-color: #d0d0d0;
  transform: translateY(-1px);
}

.event-icon {
  font-size: 48px;
  width: 96px;
  height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border-radius: 50%;
  border: none;
  align-self: center;
  margin-top: 0;
}

/* Acciones del evento */
.event-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 12px;
}

.edit-event-btn,
.delete-event-btn {
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 12px;
}

.edit-event-btn {
  background: #007bff;
  color: white;
}

.edit-event-btn:hover {
  background: #0056b3;
  transform: scale(1.1);
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);
}

.delete-event-btn {
  background: #dc3545;
  color: white;
}

.delete-event-btn:hover {
  background: #c82333;
  transform: scale(1.1);
  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
}

.edit-event-btn:active,
.delete-event-btn:active {
  transform: scale(0.95);
}

/* Iconos específicos para cada tipo de evento */
.event-item[data-type="financing"] .event-icon {
  background: rgb(230, 230, 230);
  border-color: rgb(230, 230, 230);
  color: white;
}

.event-item[data-type="purchase"] .event-icon {
  background: rgb(230, 230, 230);
  border-color: rgb(230, 230, 230);
  color: white;
}

.event-item[data-type="renovation"] .event-icon {
  background: rgb(230, 230, 230);
  border-color: rgb(230, 230, 230);
  color: white;
}

.event-item[data-type="report"] .event-icon {
  background: rgb(230, 230, 230);
  border-color: rgb(230, 230, 230);
  color: white;
}

.event-item[data-type="sale"] .event-icon {
  background: rgb(230, 230, 230);
  border-color: rgb(230, 230, 230);
  color: white;
}

/* Vista Lista */
.list-view {
  background: white;
}

.events-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.list-event-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: #f8f9fa;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.list-event-item:hover {
  background: #e9ecef;
  border-color: #dee2e6;
  transform: translateY(-2px);
}

.list-event-item.selected {
  background: #e3f2fd;
  border-color: #007bff;
}

.event-icon {
  font-size: 48px;
  width: 96px;
  height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border-radius: 50%;
  box-shadow: none;
}

.event-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.event-info .event-title {
  font-size: 16px;
  font-weight: 600;
  color: #212529;
  margin: 0;
}

.event-info .event-description {
  font-size: 14px;
  color: #6c757d;
  margin: 0;
}

.event-meta {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-top: 8px;
}

.event-dates {
  font-size: 12px;
  color: #6c757d;
  font-weight: 500;
}

.event-info .event-status {
  padding: 4px 8px;
  border-radius: 12px;
  color: white;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Estados de carga y error */

.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  color: #dc3545;
}

.error-state i {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.7;
}

.retry-btn {
  background: #dc3545;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  margin-top: 16px;
}

.retry-btn:hover {
  background: #c82333;
  transform: translateY(-2px);
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  color: #6c757d;
}

.empty-state i {
  font-size: 64px;
  margin-bottom: 20px;
  opacity: 0.5;
}

.empty-state h3 {
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: #495057;
}

.empty-state p {
  font-size: 16px;
  margin: 0 0 24px 0;
  line-height: 1.5;
}

.add-first-event-btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 16px 32px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 600;
  font-size: 16px;
}

.add-first-event-btn:hover {
  background: #0056b3;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}

/* Modal de eventos */
.event-modal {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  background: rgba(0, 0, 0, 0.5) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  z-index: 99999 !important;
  padding: 20px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  box-sizing: border-box !important;
  margin: 0 !important;
  isolation: isolate !important;
}

.event-modal * {
  box-sizing: border-box;
}

.modal-content {
  background: white !important;
  border-radius: 12px !important;
  width: 100% !important;
  max-width: 700px !important;
  max-height: calc(100vh - 40px) !important;
  display: flex !important;
  flex-direction: column !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3) !important;
  position: relative !important;
  margin: auto !important;
  overflow: hidden !important;
  z-index: 100000 !important;
  isolation: isolate !important;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
  background: white;
  border-radius: 12px 12px 0 0;
  flex-shrink: 0;
}

.modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
  background: white;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
  min-height: 0;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.required {
  color: #dc3545;
  font-weight: bold;
}

.form-input, .form-textarea, .form-select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.3s ease;
  background: white !important;
}

.form-input:focus, .form-textarea:focus, .form-select:focus {
  outline: none;
  border-color: #ff8c00;
}

.form-textarea {
  min-height: 80px;
  resize: vertical;
}

.progress-control {
  display: flex;
  align-items: center;
  gap: 12px;
}

.progress-slider {
  flex: 1;
  height: 6px;
  background: #e0e0e0;
  border-radius: 3px;
  outline: none;
  appearance: none;
}

.progress-slider::-webkit-slider-thumb {
  appearance: none;
  width: 20px;
  height: 20px;
  background: #ff8c00;
  border-radius: 50%;
  cursor: pointer;
}

.progress-value {
  font-weight: 600;
  color: #ff8c00;
  min-width: 40px;
  text-align: center;
}

.date-inputs {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.date-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}


.date-label {
  font-size: 14px;
  font-weight: 500;
  color: #555;
  margin: 0;
}

.date-picker {
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.3s ease;
  cursor: pointer;
  background: white;
  min-height: 48px;
  width: 100%;
}

.date-picker:hover {
  border-color: #ff8c00;
  background: #fff8f0;
}

.date-picker:focus {
  outline: none;
  border-color: #ff8c00;
  box-shadow: 0 0 0 3px rgba(255, 140, 0, 0.1);
  background: white;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px;
  border-top: 1px solid #e0e0e0;
  background: white;
  border-radius: 0 0 12px 12px;
  flex-shrink: 0;
}

.btn-cancel, .btn-save {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-cancel {
  background: #f8f9fa;
  color: #666;
  border: 1px solid #ddd;
}

.btn-cancel:hover {
  background: #e9ecef;
}

.btn-save {
  background: #ff8c00;
  color: white;
}

.btn-save:hover {
  background: #ff6b00;
}

/* Selector de iconos */
.icon-selector {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.icon-options {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 12px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
}

.icon-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 80px;
}

.icon-option:hover {
  border-color: #ff8c00;
  background: #fff8f0;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.icon-option.selected {
  border-color: #ff8c00;
  background: #fff8f0;
  box-shadow: 0 0 0 3px rgba(255, 140, 0, 0.2);
}

.icon-display {
  font-size: 32px;
  line-height: 1;
}

.icon-label {
  font-size: 12px;
  color: #666;
  text-align: center;
  font-weight: 500;
}

.icon-option.selected .icon-label {
  color: #ff8c00;
  font-weight: 600;
}

.icon-custom {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.icon-custom label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.icon-input {
  font-size: 24px;
  text-align: center;
  padding: 12px;
}

/* Responsive */
@media (max-width: 768px) {
  .calendar-container {
    padding: 16px;
  }
  
  .header-content {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .project-stats {
    flex-direction: column;
    gap: 16px;
  }
  
  .filter-controls {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .event-card {
    margin-left: 50px;
  }
  
  .event-dates {
    flex-direction: column;
    gap: 12px;
  }
  
  .list-event-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .event-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .event-modal {
    padding: 10px;
  }

  .modal-content {
    width: 100%;
    max-width: 100%;
    max-height: calc(100vh - 20px);
    margin: 0;
  }

  .modal-body {
    padding: 15px;
  }

  .modal-header,
  .modal-footer {
    padding: 15px;
  }

  .icon-options {
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
    gap: 8px;
  }

  .icon-option {
    padding: 8px;
    min-height: 70px;
  }

  .icon-display {
    font-size: 24px;
  }

  .icon-label {
    font-size: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/new-proyect/new-project-calendar/new-project-calendar.component.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,mBAAmB,EAAE,iCAAiC;EACtD,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;;AAGA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB,EAAE,0BAA0B;EAC/C,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB,EAAE,mBAAmB;EACvC,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB,EAAE,uBAAuB;EAC5C,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA,uDAAuD;AACvD;EACE,mBAAmB,EAAE,iCAAiC;EACtD,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,uBAAuB,EAAE,4BAA4B;EACrD,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB,EAAE,oBAAoB;EACzC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAE,kCAAkC;EACpD,UAAU,EAAE,gCAAgC;EAC5C,sBAAsB;EACtB,sCAAsC;EACtC,qBAAqB,EAAE,oCAAoC;AAC7D;;AAEA;EACE,mBAAmB,EAAE,8BAA8B;AACrD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,6BAA6B;;AAE7B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,qBAAqB;AACrB;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,yCAAyC;EACzC,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,6BAA6B;EAC7B,iCAAiC;EACjC,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,sBAAsB;EACtB,2BAA2B;EAC3B,yCAAyC;EACzC,wBAAwB;EACxB,iCAAiC;EACjC,qDAAqD;EACrD,6BAA6B;EAC7B,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,iBAAiB;EACjB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EAEb,gBAAgB;AAClB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;EACjB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;IACf,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,2DAA2D;IAC3D,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Componente principal del calendario */\n.calendar-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: 'Montserrat', sans-serif;\n  background: #f5f5f5; /* Fondo gris como en la imagen */\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n/* Header simple como en la imagen */\n.events-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding: 0 20px;\n}\n\n\n.events-title {\n  font-size: 24px;\n  font-weight: bold;\n  margin: 0;\n  color: #333;\n}\n\n.add-event-btn {\n  background: #ff8c00; /* Naranja como la barra */\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 50%; /* Botón circular */\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n}\n\n.add-event-btn:hover {\n  background: #ff6b00; /* Naranja más oscuro */\n  transform: scale(1.05);\n}\n\n/* Controles del calendario */\n.calendar-controls {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.view-controls {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.view-btn {\n  background: #f8f9fa;\n  border: 2px solid #e9ecef;\n  padding: 12px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n}\n\n.view-btn:hover {\n  background: #e9ecef;\n  border-color: #dee2e6;\n}\n\n.view-btn.active {\n  background: #007bff;\n  color: white;\n  border-color: #007bff;\n}\n\n.filter-controls {\n  display: flex;\n  gap: 24px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.filter-label {\n  font-weight: 600;\n  color: #495057;\n  font-size: 14px;\n}\n\n.filter-buttons {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.filter-btn {\n  background: white;\n  border: 2px solid #e9ecef;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.filter-btn:hover {\n  background: #f8f9fa;\n  border-color: #dee2e6;\n}\n\n.filter-btn.active {\n  background: #007bff;\n  color: white;\n  border-color: #007bff;\n}\n\n.clear-filters-btn {\n  background: #dc3545;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n}\n\n.clear-filters-btn:hover {\n  background: #c82333;\n  transform: translateY(-1px);\n}\n\n/* Contenido principal */\n.calendar-content {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Lista Simple de Eventos - Diseño como en la imagen */\n.events-list-container {\n  background: #f5f5f5; /* Fondo gris como en la imagen */\n  border-radius: 8px;\n  padding: 20px;\n  margin: 20px 0;\n}\n\n.events-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.event-item {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 0;\n  background: transparent; /* Sin fondo, todo en gris */\n  border: none;\n  cursor: default;\n}\n\n.event-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.event-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n}\n\n.event-title-simple {\n  background: #FBC773; /* Color más suave */\n  color: white;\n  padding: 12px 16px;\n  border-radius: 6px;\n  font-size: 18px;\n  font-weight: 600;\n  text-align: left; /* Texto alineado a la izquierda */\n  width: 25%; /* Solo cubre el 25% del ancho */\n  box-sizing: border-box;\n  transition: background-color 0.2s ease;\n  display: inline-block; /* Para que no ocupe todo el ancho */\n}\n\n.event-title-simple:hover {\n  background: #F4B942; /* Color más oscuro al hover */\n}\n\n.event-description {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  margin: 16px 0;\n}\n\n.description-label {\n  font-size: 16px;\n  font-weight: bold;\n  color: #333;\n  min-width: 100px;\n  flex-shrink: 0;\n  margin-top: 8px;\n}\n\n.description-input {\n  flex: 1;\n  padding: 12px 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 14px;\n  line-height: 1.4;\n  resize: vertical;\n  min-height: 60px;\n  background: white;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.description-input:focus {\n  outline: none;\n  border-color: #FBC773;\n  box-shadow: 0 0 0 3px rgba(251, 199, 115, 0.1);\n  background: #fff8f0;\n}\n\n.event-dates {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin: 16px 0;\n}\n\n.dates-label {\n  font-size: 16px;\n  font-weight: bold;\n  color: #333;\n  min-width: 100px;\n  flex-shrink: 0;\n}\n\n.dates-inputs {\n  display: flex;\n  gap: 12px;\n}\n\n.date-input {\n  padding: 10px 14px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 14px;\n  width: max-content;\n  text-align: center;\n  background: white;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  font-weight: 500;\n}\n\n.date-input:focus {\n  outline: none;\n  border-color: #FBC773;\n  box-shadow: 0 0 0 3px rgba(251, 199, 115, 0.1);\n  background: #fff8f0;\n}\n\n.date-input:hover {\n  border-color: #d0d0d0;\n  transform: translateY(-1px);\n}\n\n.event-icon {\n  font-size: 48px;\n  width: 96px;\n  height: 96px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border-radius: 50%;\n  border: none;\n  align-self: center;\n  margin-top: 0;\n}\n\n/* Acciones del evento */\n.event-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: 12px;\n}\n\n.edit-event-btn,\n.delete-event-btn {\n  border: none;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 12px;\n}\n\n.edit-event-btn {\n  background: #007bff;\n  color: white;\n}\n\n.edit-event-btn:hover {\n  background: #0056b3;\n  transform: scale(1.1);\n  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);\n}\n\n.delete-event-btn {\n  background: #dc3545;\n  color: white;\n}\n\n.delete-event-btn:hover {\n  background: #c82333;\n  transform: scale(1.1);\n  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);\n}\n\n.edit-event-btn:active,\n.delete-event-btn:active {\n  transform: scale(0.95);\n}\n\n/* Iconos específicos para cada tipo de evento */\n.event-item[data-type=\"financing\"] .event-icon {\n  background: rgb(230, 230, 230);\n  border-color: rgb(230, 230, 230);\n  color: white;\n}\n\n.event-item[data-type=\"purchase\"] .event-icon {\n  background: rgb(230, 230, 230);\n  border-color: rgb(230, 230, 230);\n  color: white;\n}\n\n.event-item[data-type=\"renovation\"] .event-icon {\n  background: rgb(230, 230, 230);\n  border-color: rgb(230, 230, 230);\n  color: white;\n}\n\n.event-item[data-type=\"report\"] .event-icon {\n  background: rgb(230, 230, 230);\n  border-color: rgb(230, 230, 230);\n  color: white;\n}\n\n.event-item[data-type=\"sale\"] .event-icon {\n  background: rgb(230, 230, 230);\n  border-color: rgb(230, 230, 230);\n  color: white;\n}\n\n/* Vista Lista */\n.list-view {\n  background: white;\n}\n\n.events-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.list-event-item {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px;\n  background: #f8f9fa;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.list-event-item:hover {\n  background: #e9ecef;\n  border-color: #dee2e6;\n  transform: translateY(-2px);\n}\n\n.list-event-item.selected {\n  background: #e3f2fd;\n  border-color: #007bff;\n}\n\n.event-icon {\n  font-size: 48px;\n  width: 96px;\n  height: 96px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border-radius: 50%;\n  box-shadow: none;\n}\n\n.event-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.event-info .event-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #212529;\n  margin: 0;\n}\n\n.event-info .event-description {\n  font-size: 14px;\n  color: #6c757d;\n  margin: 0;\n}\n\n.event-meta {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  margin-top: 8px;\n}\n\n.event-dates {\n  font-size: 12px;\n  color: #6c757d;\n  font-weight: 500;\n}\n\n.event-info .event-status {\n  padding: 4px 8px;\n  border-radius: 12px;\n  color: white;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Estados de carga y error */\n\n.error-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n  color: #dc3545;\n}\n\n.error-state i {\n  font-size: 48px;\n  margin-bottom: 16px;\n  opacity: 0.7;\n}\n\n.retry-btn {\n  background: #dc3545;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n  margin-top: 16px;\n}\n\n.retry-btn:hover {\n  background: #c82333;\n  transform: translateY(-2px);\n}\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n  color: #6c757d;\n}\n\n.empty-state i {\n  font-size: 64px;\n  margin-bottom: 20px;\n  opacity: 0.5;\n}\n\n.empty-state h3 {\n  font-size: 24px;\n  font-weight: 600;\n  margin: 0 0 8px 0;\n  color: #495057;\n}\n\n.empty-state p {\n  font-size: 16px;\n  margin: 0 0 24px 0;\n  line-height: 1.5;\n}\n\n.add-first-event-btn {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 16px 32px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.add-first-event-btn:hover {\n  background: #0056b3;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);\n}\n\n/* Modal de eventos */\n.event-modal {\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  background: rgba(0, 0, 0, 0.5) !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  z-index: 99999 !important;\n  padding: 20px !important;\n  overflow-y: auto !important;\n  overflow-x: hidden !important;\n  box-sizing: border-box !important;\n  margin: 0 !important;\n  isolation: isolate !important;\n}\n\n.event-modal * {\n  box-sizing: border-box;\n}\n\n.modal-content {\n  background: white !important;\n  border-radius: 12px !important;\n  width: 100% !important;\n  max-width: 700px !important;\n  max-height: calc(100vh - 40px) !important;\n  display: flex !important;\n  flex-direction: column !important;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3) !important;\n  position: relative !important;\n  margin: auto !important;\n  overflow: hidden !important;\n  z-index: 100000 !important;\n  isolation: isolate !important;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #e0e0e0;\n  background: white;\n  border-radius: 12px 12px 0 0;\n  flex-shrink: 0;\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #333;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.close-btn:hover {\n  color: #333;\n}\n\n.modal-body {\n  padding: 20px;\n  background: white;\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1;\n  min-height: 0;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 8px;\n}\n\n.required {\n  color: #dc3545;\n  font-weight: bold;\n}\n\n.form-input, .form-textarea, .form-select {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.3s ease;\n  background: white !important;\n}\n\n.form-input:focus, .form-textarea:focus, .form-select:focus {\n  outline: none;\n  border-color: #ff8c00;\n}\n\n.form-textarea {\n  min-height: 80px;\n  resize: vertical;\n}\n\n.progress-control {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.progress-slider {\n  flex: 1;\n  height: 6px;\n  background: #e0e0e0;\n  border-radius: 3px;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.progress-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  background: #ff8c00;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.progress-value {\n  font-weight: 600;\n  color: #ff8c00;\n  min-width: 40px;\n  text-align: center;\n}\n\n.date-inputs {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.date-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n\n.date-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #555;\n  margin: 0;\n}\n\n.date-picker {\n  padding: 12px 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 16px;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  background: white;\n  min-height: 48px;\n  width: 100%;\n}\n\n.date-picker:hover {\n  border-color: #ff8c00;\n  background: #fff8f0;\n}\n\n.date-picker:focus {\n  outline: none;\n  border-color: #ff8c00;\n  box-shadow: 0 0 0 3px rgba(255, 140, 0, 0.1);\n  background: white;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 20px;\n  border-top: 1px solid #e0e0e0;\n  background: white;\n  border-radius: 0 0 12px 12px;\n  flex-shrink: 0;\n}\n\n.btn-cancel, .btn-save {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.btn-cancel {\n  background: #f8f9fa;\n  color: #666;\n  border: 1px solid #ddd;\n}\n\n.btn-cancel:hover {\n  background: #e9ecef;\n}\n\n.btn-save {\n  background: #ff8c00;\n  color: white;\n}\n\n.btn-save:hover {\n  background: #ff6b00;\n}\n\n/* Selector de iconos */\n.icon-selector {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.icon-options {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n  gap: 12px;\n  padding: 12px;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.icon-option {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 12px;\n  background: white;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-height: 80px;\n}\n\n.icon-option:hover {\n  border-color: #ff8c00;\n  background: #fff8f0;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.icon-option.selected {\n  border-color: #ff8c00;\n  background: #fff8f0;\n  box-shadow: 0 0 0 3px rgba(255, 140, 0, 0.2);\n}\n\n.icon-display {\n  font-size: 32px;\n  line-height: 1;\n}\n\n.icon-label {\n  font-size: 12px;\n  color: #666;\n  text-align: center;\n  font-weight: 500;\n}\n\n.icon-option.selected .icon-label {\n  color: #ff8c00;\n  font-weight: 600;\n}\n\n.icon-custom {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.icon-custom label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n}\n\n.icon-input {\n  font-size: 24px;\n  text-align: center;\n  padding: 12px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .calendar-container {\n    padding: 16px;\n  }\n  \n  .header-content {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .project-stats {\n    flex-direction: column;\n    gap: 16px;\n  }\n  \n  .filter-controls {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .event-card {\n    margin-left: 50px;\n  }\n  \n  .event-dates {\n    flex-direction: column;\n    gap: 12px;\n  }\n  \n  .list-event-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  \n  .event-meta {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  \n  .event-modal {\n    padding: 10px;\n  }\n\n  .modal-content {\n    width: 100%;\n    max-width: 100%;\n    max-height: calc(100vh - 20px);\n    margin: 0;\n  }\n\n  .modal-body {\n    padding: 15px;\n  }\n\n  .modal-header,\n  .modal-footer {\n    padding: 15px;\n  }\n\n  .icon-options {\n    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\n    gap: 8px;\n  }\n\n  .icon-option {\n    padding: 8px;\n    min-height: 70px;\n  }\n\n  .icon-display {\n    font-size: 24px;\n  }\n\n  .icon-label {\n    font-size: 11px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
